import {
    MAX_BOOSTER_BULLSEYE,
    MAX_BOOSTER_JOKER,
    MAX_BOOSTER_SHUFFLE,
    MAX_BOOSTER_TNT,
    MAX_EXTRA_CARDS,
} from '../../../Constants/Player';
import {
    IPlayerState,
    IPlayerStateInventoryData,
} from '../../../State/Player/IPlayerState';
import { MathHelper } from '../../../Utility/MathHelper';
import IPlayerData from '../../IPlayerData';
import { restoreNumber } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class Inventory extends PlayerProperty<
    IPlayerStateInventoryData,
    {
        booster_tnt_col: number;
        booster_eye_col: number;
        booster_shuffle_col: number;
        free_joker: number;
        free_three: number;
    }
> {
    public readonly defaultValue: IPlayerStateInventoryData;

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData.booster_tnt_col !==
                playerStateData.inventory.boosterTNT ||
            playerEndpointData.booster_eye_col !==
                playerStateData.inventory.boosterBullsEye ||
            playerEndpointData.booster_shuffle_col !==
                playerStateData.inventory.boosterShuffle ||
            playerEndpointData.free_joker !==
                playerStateData.inventory.boosterJoker ||
            playerEndpointData.free_three !==
                playerStateData.inventory.extraCards
        );
    }

    public restore(playerEndpointData: IPlayerData): IPlayerStateInventoryData {
        return {
            boosterTNT: MathHelper.clamp(
                restoreNumber(playerEndpointData.booster_tnt_col, 0),
                0,
                MAX_BOOSTER_TNT
            ),
            boosterBullsEye: MathHelper.clamp(
                restoreNumber(playerEndpointData.booster_eye_col, 0),
                0,
                MAX_BOOSTER_BULLSEYE
            ),
            boosterShuffle: MathHelper.clamp(
                restoreNumber(playerEndpointData.booster_shuffle_col, 0),
                0,
                MAX_BOOSTER_SHUFFLE
            ),
            boosterUndo: 0,
            boosterJoker: MathHelper.clamp(
                restoreNumber(playerEndpointData.free_joker, 0),
                0,
                MAX_BOOSTER_JOKER
            ),
            boosterPlusFive: 0,
            extraCards: MathHelper.clamp(
                restoreNumber(playerEndpointData.free_three, 0),
                0,
                MAX_EXTRA_CARDS
            ),
        };
    }

    public save(playerStateData: IPlayerState) {
        return {
            booster_tnt_col: playerStateData.inventory.boosterTNT,
            booster_eye_col: playerStateData.inventory.boosterBullsEye,
            booster_shuffle_col: playerStateData.inventory.boosterShuffle,
            free_joker: playerStateData.inventory.boosterJoker,
            free_three: playerStateData.inventory.extraCards,
        };
    }
}
